import type { FileUIPart } from 'ai';

import type { Music } from '@/music/types';

export type ComposerTab = 'suggest' | 'replace';

export type SuggestionMode = 'auto' | 'generate_instrumental';

export const SUGGESTION_MODE_LABELS: Record<SuggestionMode, string> = {
  auto: '자동',
  generate_instrumental: '연주곡 생성',
};

export type SuggestionContext =
  | { type: 'recommendation'; explanation: string }
  | { type: 'segment_recommendation'; segment: string; explanation: string }
  | { type: 'generation'; segment: string | null; prompt_used: string; lyrics_used: string | null };

export interface SuggestionItem {
  music: Music;
  context: SuggestionContext;
}

export interface ReplacementItem {
  music: Music;
  replacement_start: number;
  replacement_end: number;
  explanation: string;
}

export interface SuggestionJob {
  job_id: string;
  status: 'pending' | 'running' | 'completed' | 'failed';
  stream_token: string;
}

export interface SuggestionError {
  message: string;
  retryable: boolean;
}

export interface SuggestionRequest {
  file: File | null; // data URL에서 복원한 원본 (업로드 실패 시 재시도용)
  fileId: string | null; // 업로드 완료 후 채워짐 (재시도 시 업로드 생략)
  text: string | null;
  hint: 'storyboard' | null;
  mode: SuggestionMode;
}

export interface ReplacementRequest {
  file: File | null;
  fileId: string | null;
  text: string | null;
}

export interface UserMessage {
  id: string;
  role: 'user';
  type: 'suggestion' | 'replacement';
  text: string | null;
  attachment: FileUIPart | null; // url은 data URL
  isStoryboard: boolean;
  mode: SuggestionMode;
}

export type AssistantStatus = 'uploading' | 'analyzing' | 'completed' | 'failed';

export interface AssistantMessage {
  id: string;
  role: 'assistant';
  type: 'suggestion' | 'replacement';
  status: AssistantStatus;
  items: SuggestionItem[];
  replacementItems: ReplacementItem[];
  error: SuggestionError | null;
  request: SuggestionRequest | ReplacementRequest;
}

export type Message = UserMessage | AssistantMessage;
